import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import EnvironmentManager from 'Utils/environmentManager';
import CombinationFailMessage from './Partitions/CombinationFailMessage';
import { COUPON_PLAYED, COUPON_WAITING, COUPON_REJECTED } from 'Store/constants/sportTypes';

class MultiplePlaySuccess extends Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  static propTypes = {
    playCouponState: PropTypes.object.isRequired,
    couponStatus: PropTypes.array
  }

  render () {
    const { couponStatus } = this.props;
    const { changeTotalOdds, rejectedCouponCount, timeoutCouponCount } = this.props.playCouponState || {};

    const successMessage = oddInfo => {
      return <>
        <Icon iconName='svgIconSuccess' />
        <strong>{ oddInfo.playedCount }</strong> tane kuponun <strong>{ oddInfo.totalOdd }</strong> oranından oynandı.
      </>;
    };

    const oddIncreaseSuccessMessage = oddInfo => {
      return <>
        <Icon iconName='svgIconSuccess' />
        <strong>{ oddInfo.playedCount }</strong> tane kuponun <strong>{ oddInfo.totalOdd }</strong> oranından oynandı.
      </>;
    };

    const oddDecreaseSuccessMessage = oddInfo => {
      return <>
        <Icon iconName='svgIconDown' />
        <strong>{ oddInfo.playedCount }</strong> tane kuponun <strong>{ oddInfo.totalOdd }</strong> oranından oynandı.
      </>;
    };

    return (
      <>
          { /* Group: COUPON_REJECTED + rejectedCouponCount */ }
        { (rejectedCouponCount > 0 || (couponStatus && couponStatus.some(coupon => coupon.status === COUPON_REJECTED))) && (
          <div className="cs__multiple_coupon__group cs__multiple_coupon__group__rejected">
            { couponStatus && couponStatus
              .filter(coupon => coupon.status === COUPON_REJECTED)
              .map((coupon, key) => (
                <div key={ key } className='cs__multiple_coupon__odd-changed-events--multiple'>
                  <Icon iconName='svgIconFailed' className="icon-rejected" />
                  <strong>{ coupon.playedCount }</strong> { EnvironmentManager.getMessageText({ key: 'multi_coupon_failed' }) }
                </div>
              )) }

            { rejectedCouponCount > 0 && (
              <div className='cs__multiple_coupon__odd-changed-events--multiple'>
                <Icon iconName='svgIconFailed' className="icon-rejected" />
                <strong>{ rejectedCouponCount }</strong> { EnvironmentManager.getMessageText({ key: 'multi_coupon_failed' }) }
              </div>
            ) }
          </div>
        ) }


        { /* Group: COUPON_WAITING + timeoutCouponCount */ }
        { (timeoutCouponCount > 0 || (couponStatus && couponStatus.some(coupon => coupon.status === COUPON_WAITING))) && (
          <div className="cs__multiple_coupon__group cs__multiple_coupon__group__waiting">
            { couponStatus && couponStatus
              .filter(coupon => coupon.status === COUPON_WAITING)
              .map((coupon, key) => (
                <div key={ key } className='cs__multiple_coupon__odd-changed-events--multiple'>
                  <Icon iconName='svgInfoPopularOrange' className="icon-waiting" />
                  <strong>{ coupon.playedCount }</strong> { EnvironmentManager.getMessageText({ key: 'multi_coupon_waiting' }) }
                </div>
              )) }

            { timeoutCouponCount > 0 && (
              <div className='cs__multiple_coupon__odd-changed-events--multiple'>
                <Icon iconName='svgInfoPopularOrange' className="icon-waiting" />
                <strong>{ timeoutCouponCount }</strong> { EnvironmentManager.getMessageText({ key: 'multi_coupon_waiting' }) }
              </div>
            ) }
          </div>
        ) }


        { /* Group: COUPON_PLAYED + changeTotalOdds */ }
        { (changeTotalOdds?.length > 0 || (couponStatus && couponStatus.some(coupon => coupon.status === COUPON_PLAYED))) && (
          <div className="cs__multiple_coupon__group cs__multiple_coupon__group__success">
            { couponStatus && couponStatus
              .filter(coupon => coupon.status === COUPON_PLAYED)
              .map((coupon, key) => (
                <div key={ key } className='cs__multiple_coupon__odd-changed-events--multiple'>
                  <Icon iconName='svgIconSuccess' />
                  <strong>{ coupon.playedCount }</strong> tane kuponun <strong>{ coupon.totalOdd }</strong> oranından oynandı.
                </div>
              )) }

            { changeTotalOdds && changeTotalOdds.map((oddInfo, index) => (
              <div key={ index } className='cs__multiple_coupon__odd-changed-events--multiple'>
                { oddInfo.isIncrease === 0 && successMessage(oddInfo) }
                { oddInfo.isIncrease > 0 && oddIncreaseSuccessMessage(oddInfo) }
                { oddInfo.isIncrease < 0 && oddDecreaseSuccessMessage(oddInfo) }
              </div>
            )) }
          </div>
        ) }

        <CombinationFailMessage data={ this.props.playCouponState } isListItem />
      </>
    );
  }
}

export default MultiplePlaySuccess;
